module.exports = __webpack_public_path__ + "img/9788965880325.1905f82e.jpg";